import React, { Fragment } from "react";
import { ApiResult } from "../../lib/CmsApi";
import MagazinHeader from "./MagazinHeader";
import Pagination from "../common/Pagination";
import Content from "../common/Content";
import EmptyList from "./EmptyList";
import EventArticleTeaser from "./MagazineTeaser/EventArticleTeaser";
import HeaderWithIntro from "../common/HeaderWithIntro";
import CustomPageHead from "../common/CustomPageHead";
import Seo from "../../lib/models/seo";

export interface Props {
  content: ApiResult<"loadMagazinEventPage">;
  tags: ApiResult<"listTags">;
  events: ApiResult<"listExternalEvents">["items"];
  totalEvents: number;
  page: number;
  activeTags: string[];
  seo?: Seo;
}

class EventsPagination extends Pagination<
  ApiResult<"listExternalEvents">["items"][0]
> {}
export default function EventsPage(props: Props) {
  return (
    <Fragment>
      <CustomPageHead
        title={props.content && props.content.name}
        desc={props.content && props.content.intro}
        seo={props.seo}
      />
      <MagazinHeader
        breadCrumpPath={[
          {
            title: props.content.name,
            route: "events"
          }
        ]}
        activeTab="events"
        tags={props.tags}
        activeTags={props.activeTags}
      />
      <Content padded bottomMargin as={"main"}>
        <HeaderWithIntro
          headline={props.content.name}
          intro={props.content.intro}
          size={1}
          level={2}
          blue
        />
        {props.content.highlightEvent && (
          <div>
            <EventArticleTeaser
              {...props.content.highlightEvent}
              headerImage={props.content.highlightImage}
            ></EventArticleTeaser>
          </div>
        )}
        <EventsPagination
          name={props.content.name}
          total={props.totalEvents}
          items={props.events}
          pageSize={10}
          page={props.page}
          renderItem={(item, idx) => {
            return (
              <EventArticleTeaser
                key={item._id}
                {...item}
                swap={idx % 2 === 0}
              />
            );
          }}
          renderEmpty={
            props.content.highlightEvent
              ? null
              : // eslint-disable-next-line react/display-name
                () => {
                  return <EmptyList />;
                }
          }
        />
      </Content>
    </Fragment>
  );
}

EventsPage.getImages = (props: Props) => {
  const images = [];
  if (props.content.highlightEvent) {
    const i = props.content.highlightImage;
    if (i) images.push(i);
  }
  return images;
};
